import * as React                      from 'react';
import { useHistory }                  from 'react-router-dom';
import { useCommon }                   from '../../../../providers/common';
import { useModal }                    from '../../../../providers/modal';
import CompletedProjectOrder           from '../order';
import { CompletedProjectButtonProps } from './completed-project.button.props';

const CompletedProjectButton: React.FC<CompletedProjectButtonProps> = function(props) {
  const history = useHistory();

  const { id } = props;

  const common: any = useCommon();
  const modal: any  = useModal();

  const completedProjectPage = React.useMemo(() => {
    const page = common.pages.find((page: any) => page.template === 'completed-project');

    if (!page) {
      return;
    }

    return `/${page.urlKey}`;
  }, [common.pages]);

  const onClick = React.useCallback((event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    event.stopPropagation();

    modal.showModal('Заявка на консультацию', {
      component: CompletedProjectOrder,
      props:     {
        id,
        onClose() {
          if (completedProjectPage) {
            history.replace(completedProjectPage);
          }
        },
      },
    }, false, 'completed-project-modal');
  }, [completedProjectPage, id]);

  return (
    <span
      className={'btn fill'}
      onClick={onClick}
    >Хочу такую же</span>
  );
};

export default CompletedProjectButton;